import styled from 'styled-components';

export const PaymentComponent = styled.div`
  width: 100vw;
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  font-family: 'Libre Franklin', sans-serif;
  overflow: hidden;
  height: 100vh;
`;

export const MainSection = styled.main`
  display: flex;
  flex: none;
  width: 89.333vw;
  flex-grow: 1;
  flex-direction: column;
`;

export const ContainerTitleAndIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 4vw;
  height: 5vh;
  margin-top: 2vh;
`;

export const IconConcluded = styled.img`
  width: 8.266vw;
  height: 8.266vw;
`;

export const TextConcluded = styled.h1<{ topMargin?: string }>`
  font-weight: 700;
  font-size: 5.333vw;
  font-family: 'Libre Franklin', sans-serif;
  margin-top: ${(props) => props.topMargin || 0};
`;

export const ContainerInfo = styled.div`
  border: solid #ededed 0.266vw;
  border-radius: 2.66vw;
  width: 89.33vw;
  max-height: 86.13vw;
  margin-top: 4.26vw;
  padding: 5.3vw 4.53vw 5.3vw 4.53vw;
  box-sizing: border-box;
  overflow: auto;
`;

export const ContainerService = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  p {
    font-size: 5.3vw;
    font-family: 'Libre Franklin', sans-serif;
    font-weight: 700;
    width: 65.8vw;
  }
`;

export const IconCase = styled.img`
  width: 4.26vw;
  height: 4.26vw;
  margin-right: 2.13vw;
`;

export const ArrowUpIcon = styled.img<{ transform: string }>`
  width: 3.8vw;
  height: 4.424vw;
  right: 1.77vw;
  transform: ${(props) => props.transform};
  position: absolute;
`;

export const ContainerHourAddress = styled.div`
  margin-top: 3.73vw;
  display: flex;
  flex-direction: column;
`;

export const ContainerRow = styled.div<{ gap: string }>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap};
  margin-top: 1.3vw;
  align-items: center;
`;

export const IconClock = styled.img`
  width: 3.2vw;
  height: 3.46vw;
`;

export const IconOnline = styled.img`
  width: 4vw;
  height: 3.4vw;
`;

export const TextMeet = styled.p`
  font-size: 3.2vw;
  font-family: 'Libre Franklin', sans-serif;
  margin-top: 1.3vw;
  font-weight: 500;
  margin-left: 6.13vw;
`;

export const TextInfo = styled.p`
  font-family: 'Libre Franklin', sans-serif;
  font-size: 3.2vw;
  font-weight: 700;
`;

export const IconFaceToFace = styled.img`
  width: 3.73vw;
  height: 3.46vw;
`;

export const TextAddress = styled.p`
  font-size: 3.2vw;
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 500;
  margin-top: 1.3vw;
  margin-left: 6.13vw;
`;

export const ContainerConsultant = styled.div`
  width: 89.33vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2.66vw;
  margin-top: 6.1vw;
`;

export const ImageConsultant = styled.img`
  width: 11.2vw;
  height: 11.2vw;
  border-radius: 50vw;
`;

export const ContainerName = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-family: 'Libre Franklin', sans-serif;
    font-weight: 500;
    font-size: 3.2vw;
  }
  h1 {
    font-family: 'Libre Franklin', sans-serif;
    font-weight: 700;
    font-size: 4vw;
  }
`;
